import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Locate = createReactComponent("Locate", ["svg", defaultAttributes, [["line", {
  x1: "2",
  x2: "5",
  y1: "12",
  y2: "12",
  key: "sajh3r"
}], ["line", {
  x1: "19",
  x2: "22",
  y1: "12",
  y2: "12",
  key: "1kevsh"
}], ["line", {
  x1: "12",
  x2: "12",
  y1: "2",
  y2: "5",
  key: "gdek53"
}], ["line", {
  x1: "12",
  x2: "12",
  y1: "19",
  y2: "22",
  key: "on13co"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "7",
  key: "f8eh5q"
}]]]);
export default Locate;